import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-remove-confirm-dialog',
  templateUrl: './remove-confirm-dialog.component.html',
  styleUrls: ['./remove-confirm-dialog.component.scss']
})
export class RemoveConfirmDialogComponent {

  @Input() title: string;

  constructor(protected ref: NbDialogRef<RemoveConfirmDialogComponent>) {
  }

  onConfirm() {
    this.ref.close(true);
  }

  onDismiss() {
    this.ref.close(false);
  }

}
